import interpolateComponents from '@automattic/interpolate-components';
import type { ReactNode } from 'react';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';

type Args = {
  orgUrl: string | undefined;
  orgPublishedEventsCount: number;
};

export function getUnpublishedEventPageSeeMoreText({
  orgUrl,
  orgPublishedEventsCount,
}: Args): ReactNode {
  if (!orgUrl) {
    return getText('Search below for an event title that interests you.');
  }

  const link = (
    <StyledVersionedRouterLink
      to={orgUrl}
      data-qa-id="view-event-page-unpublished-view-organization-opportunities"
    />
  );

  if (orgPublishedEventsCount > 0) {
    return interpolateComponents({
      mixedString: getText(
        'You can see more {{link}}events by this organization{{/link}}, or search below',
      ),
      components: { link },
    });
  }

  return interpolateComponents({
    mixedString: getText(
      'You can learn more about {{link}}the organization that posted this listing{{/link}}, or search below',
    ),
    components: { link },
  });
}
